import * as React from "react";
import * as Moment from 'moment';
import { DatePickerNoForm } from "../forms/informedv2/DatePicker";

interface BreakdownFilterProps {
    onFilter: (from, to) => void;
}

export const BreakdownFilter = ({ onFilter }: BreakdownFilterProps) => {
    const [from, setFrom] = React.useState<string>();
    const [to, setTo] = React.useState<string>();

    const format = 'YYYY-MM-DD';

    const handleFromChange = (value) => {
        setFrom(Moment(value).format(format));
    }

    const handleToChange = (value) => {
        setTo(Moment(value).format(format));
    }

    return (
        <div id="sessionStatusFilterDropDown" className="btn-group">
            <button type="button" className="btn btn-primary fas fa-filter dropdown-toggle" data-toggle="dropdown">
                <span className="caret"></span>
            </button>
            <ul className="dropdown-menu scrollable-menu" style={{ width: 350 + 'px', padding: 15 + 'px' }} >
                <li>
                    <div className='row'>
                        <div className='col-md-6 form-group'>
                            <label>From</label>
                            <DatePickerNoForm onChange={handleFromChange} value={from} className='form-control' placeholder="" from={true} />
                        </div>
                        <div className='col-md-6 form-group'>
                            <label>To</label>
                            <DatePickerNoForm onChange={handleToChange} value={to} className='form-control' placeholder="" from={false} />
                        </div>
                    </div>
                    <div style={{ marginTop: 5 + 'px'}}>
                        <button id="dropDownFilterButton" className="btn btn-primary" onClick={() => onFilter(from, to)}>Filter</button>
                    </div>
                </li>
            </ul>
        </div>
    );
}
